import { combineReducers } from "redux"
import get from "lodash/get"

// Front
import Layout from "./layout/reducer"

// Authentication
import Login from "./auth/login/reducer"

//Dashboard
import Dashboard from "./dashboard/reducer"

//Roles
import roles from "./roles/reducer"

//Permissions
import permissions from "./permissions/reducer"

//Admin users
import users from "./users/reducer"

//Products
// import products from "./products/reducer"

// //Products
// import operatorProducts from "./operatorProducts/reducer"

// //Channels
// import productChannels from "./channels/reducer"

// //Categoreis
// import productCategories from "./categories/reducer"

// //Suppliers
// import suppliers from "./suppliers/reducer"

// //Risk Management
// import riskManagement from "./riskManagement/reducer"

// //Bonuses
// import bonuses from "./Bonuses/reducer"

// //Multi Bet Bonus
// import multiBetBonuses from "./MultiBetBonus/reducer"

// //Acca7
// import acca7 from "./Acca7/reducer"

//Jackpots
import jackpots from "./jackpots/reducer"

//Events
import events from "./events/reducer"

//Marketing Promotions
// import marketing from "./Marketing/reducer"

// //Static Pages
// import staticPages from "./StaticPages/reducer"

//Shops
import shops from "./Admin/shops/reducer"

//Sports
// import sports from "./Sports/reducer"

// //Markets
// import markets from "./markets/reducer"

// //Cashiers
// import cashiers from "./cashier/reducer"

// //Content
// import content from "./Content/reducer"

// //common Reducer
// import common from "./users/reducer"
import { API_ERROR } from "./actionTypes"

const CommonState = (state = [], action) => {
  const payload = get(action, "payload", null)
  switch (action.type) {
    case API_ERROR:
      return payload

    default:
      return state
  }
}
const rootReducer = combineReducers({
  // public
  Layout,
  Login,
  Dashboard,
  roles,
  permissions,
  users,
  CommonState,
  // operatorProducts,
  // products,
  // productChannels,
  // productCategories,
  // suppliers,
  // riskManagement,
  // bonuses,
  // multiBetBonuses,
  // acca7,
  jackpots,
  events,
  // marketing,
  // staticPages,
  shops,
  // sports,
  // cashiers,
  // markets,
  // content,
})

export default rootReducer
